import { render } from "./TemplatesView.vue?vue&type=template&id=30085e4a&scoped=true"
import script from "./TemplatesView.vue?vue&type=script&lang=js"
export * from "./TemplatesView.vue?vue&type=script&lang=js"

import "./TemplatesView.vue?vue&type=style&index=0&id=30085e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30085e4a"]])

export default __exports__